var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4750_32550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50271 17.274C9.84075 17.274 10.1148 16.9999 10.1148 16.6619C10.1148 16.3238 9.84075 16.0498 9.50271 16.0498C9.16466 16.0498 8.89062 16.3238 8.89062 16.6619C8.89062 16.9999 9.16466 17.274 9.50271 17.274Z",
    fill: "#1F342F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0313 0.929688H5.96969C4.94385 0.929688 4.10938 1.76425 4.10938 2.79001V17.0694C4.10938 18.0951 4.94393 18.9297 5.96969 18.9297H13.0314C14.0571 18.9297 14.8917 18.0951 14.8917 17.0694V2.79001C14.8916 1.76425 14.0571 0.929688 13.0313 0.929688ZM5.30937 4.56993H13.6916V14.5616H5.30937V4.56993ZM5.96969 2.12969H13.0314C13.3955 2.12969 13.6917 2.42593 13.6917 2.79001V3.36993H5.30937V2.79001C5.30937 2.42593 5.60553 2.12969 5.96969 2.12969ZM13.0313 17.7297H5.96969C5.60561 17.7297 5.30937 17.4334 5.30937 17.0694V15.7615H13.6916V17.0694C13.6916 17.4334 13.3955 17.7297 13.0313 17.7297Z",
    fill: "#1F342F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4750_32550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.929688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneIcon);
export default __webpack_public_path__ + "static/media/iphone-icon.284d14b2e7897c81a7cb0097f0c29b6f.svg";
export { ForwardRef as ReactComponent };